import { render, staticRenderFns } from "./carouselForSingleStoryView.vue?vue&type=template&id=3f6da118&"
import script from "./carouselForSingleStoryView.vue?vue&type=script&lang=js&"
export * from "./carouselForSingleStoryView.vue?vue&type=script&lang=js&"
import style0 from "./carouselForSingleStoryView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports